import { render, staticRenderFns } from "./send_auth.vue?vue&type=template&id=3d5f41a6&lang=pug&"
import script from "./send_auth.vue?vue&type=script&lang=js&"
export * from "./send_auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5f41a6')) {
      api.createRecord('3d5f41a6', component.options)
    } else {
      api.reload('3d5f41a6', component.options)
    }
    module.hot.accept("./send_auth.vue?vue&type=template&id=3d5f41a6&lang=pug&", function () {
      api.rerender('3d5f41a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register_user/send_auth.vue"
export default component.exports